import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setDollarConversionLevels } from './dollar-conversion-level.actions';
export const securityLevelValues = createReducer([], on(setDollarConversionLevels, (state, action) => {
    return action.securityLevelValues;
}), on(resetAllCustomPdfReportItems, () => {
    return [];
}));
